import { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { signOut } from "../config/msal";
import { LoadingState } from "../components/ui";

export default function LogoutPage() {
  const { instance, inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    const activeAccount = instance.getActiveAccount();

    if (!activeAccount) {
      navigate("/", { replace: true });
      return;
    }

    void (async () => {
      await signOut(instance);
      navigate("/", { replace: true });
    })();
  }, [instance, inProgress, navigate]);

  return <LoadingState h={400} message="Signing out…" />;
}
